import { getBulkActionButtonConfig } from "@components/common/faro-table/bulk-actions/bulk-actions-config";
import { FaroTextButton } from "@components/common/faro-text-button";
import { BulkRemoveFromProjectsDialog } from "@components/table/member-group-projects/bulk-actions/bulk-remove-from-projects-dialog";
import { BaseMemberAndTeamProps } from "@custom-types/member-types";
import { Text, DeleteIcon } from "@flat-ui";
import { useBulkActionsMode } from "@hooks/use-bulk-actions-mode";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { useState } from "react";

interface Props extends BaseMemberAndTeamProps {
  /** The projects currently shown in the group */
  projects: FaroCoreApiTypes.ProjectSummary[];

  /** Callback after successful removal with the IDs of removed projects */
  onSuccessfulComplete(removedProjectIds: string[]): void;
}

/** Bulk action button that opens a dialog to remove a member/team from selected projects */
export function BulkRemoveFromProjects({
  member,
  projects,
  onSuccessfulComplete,
}: Props): JSX.Element {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const mode = useBulkActionsMode();
  const bulkActionConfig = getBulkActionButtonConfig(mode, "Remove member");

  return (
    <>
      <FaroTextButton
        onClick={() => setIsDialogOpen(true)}
        tooltipText={bulkActionConfig.tooltipText}
        sx={{ ...bulkActionConfig.sx }}
        startIcon={<DeleteIcon width={18} height={18} />}
        rippleColor={bulkActionConfig.rippleColor}
      >
        {bulkActionConfig.shouldShowText && (
          <Text variant="buttonM">Remove member</Text>
        )}
      </FaroTextButton>

      <BulkRemoveFromProjectsDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        member={member}
        projects={projects}
        onSuccessfulComplete={onSuccessfulComplete}
      />
    </>
  );
}
